import { render } from "./CreateUserCard.vue?vue&type=template&id=f3065bce"
import script from "./CreateUserCard.vue?vue&type=script&lang=js"
export * from "./CreateUserCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__